import React from 'react'
import { v4 as uuidv4 } from 'uuid'; 
import BreadcrumbIndexEntry from './BreadcrumbIndexEntry';
export default function BreadcrumbIndexList({list,pickupBreadcrumbs}) {
    console.log("BreadcrumbIndexEntry:",list);
    // console.log("BreadcrumbIndexEntry:",list.list;
    // console.log("BreadcrumbIndexEntry[0]:",list[0]);
    let index=-1;
    return (
        list.map(breadcrumb=> {
            ++index;
            return <BreadcrumbIndexEntry key={index} breadcrumb={breadcrumb} pickupBreadcrumbs={pickupBreadcrumbs}></BreadcrumbIndexEntry>
        })
    )
}
